import { render, staticRenderFns } from "./PointsExchangeDialog.vue?vue&type=template&id=29dc211f&"
import script from "./PointsExchangeDialog.vue?vue&type=script&lang=js&"
export * from "./PointsExchangeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports